Middleware = require("lib/middleware")

Application =
  actions:   Middleware.actions
  action:    Middleware.action
  publish:   Middleware.publish
  subscribe: Middleware.subscribe

  initialize: (platform, isPlayer) ->
    @isPlayer = isPlayer
    window.iostap.initialize(allowDefault: -> true)
    Middleware.initialize(platform)

    require("lib/i18n").initialize("en")

    # Require the router during initialization to avoid infinite requiring
    # The router is a singleton that handles app-wide navigation
    Router  = require("lib/router")
    @router = new Router()

    Analytics = Middleware.actions("Analytics")
    Analytics.startTracking()

    Lesson = Middleware.actions("Lesson")
    Lesson.open()

    # Everything is now loaded, so start Backbone.history
    Backbone.history.start()
    console.log("HISTORY START")

# Application is a global variable to be able to access it outside of the window
module.exports = window.Application = Application